<template>
  <div class="mod-rm__coursevehiclerela">

    <div style="margin-top: 5px;">
      <el-row :gutter="10">
        <!--查询车辆-->
        <el-col :span="18">
          <!--添加车辆-->
          <el-card class="box-card">
            <el-row>
              <el-col>
                <div ref="queryBox"
                     class="queryBox">
                  <el-form :label-position="labelPosition"
                           :label-width="queryLabelWidth"
                           @submit.native.prevent
                           @keyup.enter.native="queryVehiclerela()"
                           :model="dataForm">
                    <el-row :gutter="0">
                      <!-- 车型分类 -->
                      <el-col :span="6">
                        <el-form-item prop="vehicleClassList"
                                      style="width: 98%!important;"
                                      :label="$t('res.vehinfo.vehicleClassId')">
                          <class-tree ref="classRef"
                                      v-on:getSelectList="getVehicleList"
                                      v-bind:defaultProps="VehicleProps"
                                      v-bind:url="queryVehicleUrl"
                                      v-bind:isSelect=false
                                      v-bind:status="'classStatus'"></class-tree>
                        </el-form-item>
                      </el-col>
                      <!-- 车辆标签 -->
                      <el-col :span="6">
                        <el-form-item style="height: 34px;width: 98%!important;">
                          <span slot="label">
                            <el-link type="primary"
                                     :underline="false"
                                     slot="reference"
                                     @click.native.prevent="showSuboLableDlg">{{ $t('res.vehinfo.label')}}</el-link>
                          </span>
                          <div class="el-input el-input--default el-input__inner el-form-item__content"
                               style="height:30px;"
                               @mouseenter="vehicleLabelShow()"
                               @mouseleave="vehicleLabelLeave()">
                            <div style="width:80%;float:left;"
                                 class="holder"
                                 contenteditable="false"
                                 :placeholder="$t('cert.selectTips')">{{this.dataForm.labelTypeName}}</div>
                            <el-link type="primary"
                                     :underline="false"
                                     class="el-icon-error link-delete-temp"
                                     ref="templateNameLink"
                                     v-show="vehicleLabelShowFlg && dataForm.labelTypeName != '' && dataForm.labelTypeName != null"
                                     style="float:right;margin-top:9px;color:rgba(0,0,0,.3);"
                                     @click="vehicleLabelName()"></el-link>
                          </div>
                        </el-form-item>
                      </el-col>
                      <!-- 车辆分类 -->
                      <el-col :span="6">
                        <el-form-item :label="$t('res.vehinfo.vehicleClassification')"
                                      style="width: 98%!important;">
                          <el-select multiple
                                     collapse-tags
                                     v-model="dataForm.vehicleClassificationList"
                                     clearable>
                            <el-option v-for="(item,index) in vehicleClassArr"
                                       :key="index"
                                       :label="item.name"
                                       :value="item.code">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item>
                          <el-button style="margin-bottom: 7px"
                                     type="primary"
                                     @click="queryVehiclerela()">{{ $t('query') }}</el-button>
                        </el-form-item>
                      </el-col>
                      <!-- 第二行 -->
                      <el-col :span="6">
                        <!-- 车辆底盘号 -->
                        <el-form-item :label="$t('res.vehinfo.chassisNo')"
                                      style="width: 98%!important;">
                          <el-input v-model="dataForm.chassisNo"
                                    :placeholder="$t('res.vehinfo.input')"
                                    clearable></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <!-- 所属场地 -->
                        <el-form-item style="height: 34px;width: 98%!important;">
                          <span slot="label">
                            <el-link type="primary"
                                     :underline="false"
                                     slot="reference"
                                     @click.native.prevent="showSuboSiteDlg">{{ $t('res.vehinfo.subordinateSiteId')}}</el-link>
                          </span>
                          <div class="el-input el-input--default el-input__inner el-form-item__content"
                               style="height:30px;"
                               @mouseenter="siteSeleteShow()"
                               @mouseleave="siteSeleteLeave()">
                            <div style="width:80%;float:left;"
                                 class="holder"
                                 contenteditable="false"
                                 :placeholder="$t('cert.selectTips')">{{this.dataForm.subordinateSiteName}}</div>
                            <el-link type="primary"
                                     :underline="false"
                                     class="el-icon-error link-delete-temp"
                                     ref="siteNameLink"
                                     v-show="siteSeleteShowFlg && dataForm.subordinateSiteName != '' && dataForm.subordinateSiteName != null"
                                     style="float:right;margin-top:9px;color:rgba(0,0,0,.3);"
                                     @click="siteSeleteName()"></el-link>
                          </div>
                        </el-form-item>
                      </el-col>
                      <!-- 当前场地 -->
                      <el-col :span="6">
                        <el-form-item :label="$t('res.vehinfo.presentSiteId')"
                                      style="width: 98%!important;">
                          <el-input v-model="dataForm.presentSiteName"
                                    :placeholder="$t('res.vehinfo.input')"
                                    clearable></el-input>
                        </el-form-item>
                      </el-col>
                      <!--车辆状态-->
                      <el-col :span="6">
                        <el-form-item v-if="false"
                                      style="width: 98%!important;"
                                      :label="$t('res.vehinfo.status')">
                          <el-select multiple
                                     collapse-tags
                                     v-if="false"
                                     v-model="dataForm.statusList"
                                     :placeholder="$t('res.vehinfo.status')"
                                     clearable>
                            <el-option v-for="(item,index) in statusArr"
                                       :key="index"
                                       :label="item.name"
                                       :value="item.code">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="1">
                        <el-form-item>
                          <el-button class="el-back"
                                     type="info"
                                     @click="resetQueryData()">{{ $t('reset') }}</el-button>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </el-col>
            </el-row>

            <!-- 数据网格 -->
            <div class="dataBox">
              <el-table border
                        ref="selectVehicleinfo"
                        :data="dataList"
                        v-loading="dataListLoading"
                        size="mini"
                        stripe
                        style="width: 100%;"
                        @select="selectRedio"
                        @select-all="selectAllRedio">
                <el-table-column type="selection"
                                 header-align="center"
                                 align="center"
                                 width="50"
                                 :selectable='checkboxT'>
                </el-table-column>
                <el-table-column prop="xh"
                                 fixed
                                 :label="$t('res.cri.serialNo')"
                                 type="index"
                                 min-width="55"
                                 header-align="center"
                                 align="center" />
                <el-table-column prop="id"
                                 header-align="center"
                                 v-if="false"
                                 align="center"
                                 :label="$t('res.vehinfo.id')">
                </el-table-column>
                <!-- 车辆底盘号 -->
                <el-table-column prop="chassisNo"
                                 header-align="center"
                                 align="center"
                                 show-overflow-tooltip
                                 :label="$t('res.vehinfo.chassisNo')">
                </el-table-column>
                <!-- 车型分类 -->
                <el-table-column prop="classCnName"
                                 header-align="center"
                                 align="center"
                                 show-overflow-tooltip
                                 :label="$t('res.vehinfo.vehicleClassId')">
                </el-table-column>
                <!-- 所属公司 -->
                <el-table-column prop="companyCnName"
                                 header-align="center"
                                 align="center"
                                 show-overflow-tooltip
                                 :label="$t('res.cri.site.siteId')">
                </el-table-column>
                <!-- 所属场地 -->
                <el-table-column prop="siteCnName"
                                 header-align="center"
                                 align="center"
                                 show-overflow-tooltip
                                 :label="$t('res.vehinfo.subordinateSiteId')">
                </el-table-column>
                <!-- 当前场地 -->
                <el-table-column prop="presentSiteName"
                                 header-align="center"
                                 align="center"
                                 show-overflow-tooltip
                                 :label="$t('res.vehinfo.presentSiteId')">
                </el-table-column>
                <!-- 车辆分类 -->
                <el-table-column prop="vehicleClassification"
                                 :formatter="vehicleClassFormatter"
                                 header-align="center"
                                 align="center"
                                 show-overflow-tooltip
                                 :label="$t('res.vehinfo.vehicleClassification')">
                </el-table-column>
                <!--车辆标签-->
                <el-table-column prop="label"
                                 header-align="center"
                                 align="center"
                                 :label="$t('res.vehinfo.label')">
                  <template slot-scope="scope">
                    <!--查看-->
                    <span class="el-dropdown-link"
                          v-if="scope.row.number !== null"
                          @click="checkLable(scope.row)">{{ $t('res.vehinfo.check') }}</span>
                  </template>
                </el-table-column>
                <!--是否有车辆配置信息-->

                <!-- 状态 -->
              </el-table>
              <el-pagination @size-change="pageSizeChangeHandle"
                             @current-change="pageCurrentChangeHandle"
                             :current-page="page"
                             :page-sizes="[10, 20, 50, 100]"
                             :page-size="limit"
                             layout="total, sizes, prev, pager, next, jumper"
                             :total="total">
              </el-pagination>
            </div>
          </el-card>
        </el-col>

        <!--已选培训师-->
        <el-col :span="6">
          <el-card class="box-card">
            <div>
              <span class="dataBox">{{$t('res.vehinfo.selected')}}</span>
              <div>
                <el-row :gutter="10">
                  <el-col v-for="tag in vehicleData"
                          :key="tag.chassisNo">
                    <el-tag show-overflow-tooltip
                            style="margin-bottom: 10px;width: 250px"
                            :key="tag.chassisNo"
                            @close="handleClose(tag)"
                            closable>{{tag.chassisNo}}</el-tag>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-card>
          <div style="text-align:right;">
            <el-button size="mini"
                       type="primary"
                       @click="closeSuboVehicleDlg">取 消</el-button>
            <el-button size="mini"
                       type="primary"
                       @click="onOk">确 定</el-button>
          </div>
        </el-col>

      </el-row>
    </div>
    <!-- 所属场地dialog -->
    <subordinate-site ref="suborSiteRef"
                      :isSingleElection='false'
                      :isShow='false'
                      :isQueryShow="true"
                      v-bind:selectTable="siteSelectTable"
                      v-bind:statusList="statusList"
                      :dialogVisible="isShowSuboSite"
                      v-on:closeSuboSiteDlg="closeSuboSiteDlg"
                      v-on:bringBack="bringBack"></subordinate-site>
    <!-- 标签查看 -->
    <el-dialog title="标签查看"
               :visible="isShowLable"
               width="70%"
               :before-close="showLableClose"
               :modal-append-to-body='false'
               append-to-body>
      <el-form label-position="top"
               label-width="150px"
               :ref="dataForm"
               ref="dataForm">
        <div>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="tagName"
                            style="width: 100%!important;">
                <tag :checkedList="checkList"
                     :moduleId="moduleId"
                     :overLabelShow="false"
                     :closeShow="false"
                     :bussinessTypeId="bussinessTypeId"
                     :brandCode="bussinessTypeChecked"
                     @getBussinessType="getBussinessType"
                     @changeCheckedList="changeCheckedList"
                     ref='tagTree'
                     @fatherMethod="fatherMethod"></tag>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>
    <!--标签查询条件-->
    <el-dialog title="选择标签"
               :visible="isQueryShowLable"
               width="70%"
               :before-close="showQueryLableClose"
               :modal-append-to-body='false'
               append-to-body>
      <el-form label-position="top"
               label-width="150px"
               :ref="dataForm"
               ref="dataForm">
        <div>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="tagName"
                            style="width: 100%!important;">
                <tag :checkedList="checkList"
                     :moduleId="moduleId"
                     :overLabelShow="true"
                     :closeShow="true"
                     :bussinessTypeId="bussinessTypeId"
                     :brandCode="bussinessTypeChecked"
                     @getBussinessType="getBussinessType"
                     @changeCheckedList="changeCheckedList"
                     ref='tagTree'
                     @fatherMethod="fatherMethod"></tag>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div>
        <el-button type="primary"
                   @click="onOkLable">{{ $t('res.rela.determine') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import mixinViewModule from '@/mixins/view-module'
import Vue from 'vue'
import ClassTree from '@/components/rm/class-tree/index'
import subordinateSite from '@/components/rm/subordinateSite-calendar/index'
import Tag from '@/components/rm/label-select/index'
import VueI18n from '@/i18n'
export default {
  props: {
    vehicleInfoList: {
      type: Array,
      required: false
    },
    vehicleList: null
    // selectTable: {
    //   type: Array,
    //   required: false
    // }
  },
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/rm/vehicleinfo/list',
        getDataListIsPage: true,
        deleteURL: '/rm/vehicleinfo/delete',
        deleteIsBatch: true,
        exportURL: '/rm/vehicleinfo/export'
      },
      dataForm: {
        courseNo: '',
        chassisNo: '',
        label: [],
        labelTypeName: '',
        coursecName: '',
        classCnNames: '',
        teamcName: '',
        vehicleClassification: '',
        priority: '',
        stationName: '',
        subordinateSiteName: '',
        subordinateSiteIdList: [],
        statusList: ['10']
      },
      dataForms: {
        priority: ''
      },
      siteSelectTable: [],
      statusList: ['10'],
      siteSeleteShowFlg: false,
      vehicleLabelShowFlg: false,
      isQueryShowLable: false,
      isShowLable: false,
      checkList: [],
      // 模块id，20 代表组织管理模块
      moduleId: '20',
      bussinessTypeId: 16,
      bussinessTypeChecked: 16,
      statusArr: this.enums['status'], 
      vehicleData: [],
      // 编辑面板标签对齐方式
      labelPosition: 'left',
      // 查询面板标签宽度
      queryLabelWidth: '85px',
      labelList: [], // 标签
      vehicleClassArr: this.enums['vehicleClass'], // 车型分类
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      priorityArr: this.enums['priority'], // 优先级
      dataListLoading: false,
      // subordinateSiteId: '',
      // subordinateSiteName: '',
      dataListSelections: [],
      addOrUpdateVisible: false,
      // 车型分类树
      VehicleProps: {
        children: 'children',
        label: 'classCnName'
      },
      queryVehicleUrl: '/rm/vehicleclass/list',
      // 是否显示所属场地
      isShowSuboSite: false,
      dataRule: {
        priority: [
          { required: true, message: this.$t('res.rela.priorityCheck'), trigger: 'blur' }
        ]
      }
    }
  },
  components: {
    Tag,
    'class-tree': ClassTree,
    'subordinate-site': subordinateSite
  },
  mounted () {
    this.initMethods()
  },
  methods: {
    // 点击选择标签打开弹窗
    showSuboLableDlg () {
      this.isQueryShowLable = true
    },
    //关闭选择标签弹窗
    showQueryLableClose () {
      this.isQueryShowLable = false
    },
    onOkLable () {
      let args = this.checkList
      if (args && args !== '' && args.length > 0) {
        let vehicleLabelinfo = []
        let vehicleLabelinfoName = []
        args.forEach(function (item) {
          vehicleLabelinfo.push(item.labelId)
          vehicleLabelinfoName.push(item.labelName)
        })
        this.dataForm.label = vehicleLabelinfo
        this.dataForm.labelTypeName = vehicleLabelinfoName.join(',')
      } else {
        this.dataForm.label = ''
      }
      this.isQueryShowLable = false
    },
    checkLable (row) {
      this.isShowLable = true
      this.$request.get(`/rm/vehicleinfo/info/${row.id}`).then((data) => {
        // 已选择的标签
        this.checkList = data.commLabelVoList ? data.commLabelVoList : []
        // 特殊情况，自己国际化
        const language = VueI18n.locale
        if (language === 'zh-CN') {
          // this.checkList.forEach(o => {
          //   o.labelName = o.labelNameCn
          // })
          for (let i = 0; i < this.checkList.length; i++) {
            if (this.checkList[i].labelNameCn !== null) {
              this.checkList[i].labelName = this.checkList[i].labelNameCn
            } else {
              this.checkList.splice(i, 1)
              i--
            }
          }
        } else {
          // this.checkList.forEach(o => {
          //   o.labelName = o.labelNameEn
          // })
          for (let i = 0; i < this.checkList.length; i++) {
            if (this.checkList[i].labelNameEn !== null) {
              this.checkList[i].labelName = this.checkList[i].labelNameEn
            } else {
              this.checkList.splice(i, 1)
              i--
            }
          }
        }
      })
    },
    showLableClose () {
      this.isShowLable = false
    },
    getBussinessType (val) {
      this.dataForm.bussinessTypeId = 16
      this.bussinessTypeId = 16
    },
    changeCheckedList (array) {
      this.checkList = array
    },
    // 重新勾选业务标签
    fatherMethod () {
      this.checkList = []
      // 已选择的标签
      this.checkList = this.dataForm.commLabelVoList ? this.dataForm.commLabelVoList : []
      // 特殊情况，自己国际化
      const language = VueI18n.locale
      if (language === 'zh-CN') {
        this.checkList.forEach(o => {
          o.labelName = o.labelNameCn
        })
      } else {
        this.checkList.forEach(o => {
          o.labelName = o.labelNameEn
        })
      }
    },
    // 下载文件
    downloadFile (row) {
      let requestUrl = window.SITE_CONFIG['apiBaseURL'] + '/file/file/fastDownload'
      let dlform = document.createElement('form')
      dlform.method = 'post'
      dlform.action = requestUrl
      let hdnFilePath = document.createElement('input')
      hdnFilePath.type = 'hidden'
      hdnFilePath.name = 'id'
      hdnFilePath.value = row.fileId
      dlform.appendChild(hdnFilePath)
      document.body.appendChild(dlform)
      dlform.submit()
      document.body.removeChild(dlform)
    },
    // 获取数据列表
    getDataList () {
      let newDataForm = JSON.parse(JSON.stringify(this.dataForm))
      if ('regionIds' in newDataForm) {
        if (newDataForm.regionIds.length === 0) {
          newDataForm.regionIds = ''
        } else {
          newDataForm.regionIds = newDataForm.regionIds.join(',')
        }
      }
      this.dataListLoading = true
      this.$request.get(
        this.mixinViewModuleOptions.getDataListURL,
        {
          order: this.order,
          orderField: this.orderField,
          page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
          limit: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
          ...newDataForm
        }
      ).then((res, total, code, data) => {
        console.log(res)
        this.dataListLoading = false
        let resultList = data.result
        // this.dataList = this.mixinViewModuleOptions.getDataListIsPage ? data.result.list : resultList
        this.dataList = resultList
        this.total = this.mixinViewModuleOptions.getDataListIsPage ? data.total : 0
        // 延迟加载
        this.$nextTick(() => {
          this.querSelect()
        })
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    initMethods () {
      this.dataForm = {
        courseNo: '',
        chassisNo: '',
        label: [],
        labelTypeName: '',
        coursecName: '',
        classCnNames: '',
        teamcName: '',
        vehicleClassification: '',
        priority: '',
        stationName: '',
        subordinateSiteName: '',
        subordinateSiteIdList: [],
        statusList: ['10']
      }
      // 将已选场地清空
      this.vehicleData = []

      this.siteSelectTable = []
      if (this.vehicleList && this.vehicleList.length > 0) {
        this.vehicleData = JSON.parse(JSON.stringify(this.vehicleList))
      }
      // this.resetQueryData()
      this.getDataList()
    },
    // 单选
    selectRedio: function selectRedio (selection, row) {
      let result = []
      for (let a = 0; a < selection.length; a++) {
        if (row.chassisNo === selection[a].chassisNo) {
          result.push(row)
          break
        }
      }
      if (result.length > 0) {
        if (this.isSelectElection && this.$refs.selectVehicleinfo.selection.length > 1) {
          this.$refs.selectVehicleinfo.clearSelection()// 清空
          this.vehicleData = []
          this.vehicleData.push(row)
          this.$refs.selectVehicleinfo.toggleRowSelection(row)// 选择当前行
        } else {
          if (row) {
            this.vehicleData.push(row)
          }
        }
      } else {
        if (this.isSelectElection && this.$refs.selectVehicleinfo.selection.length > 1) {
          this.$refs.selectVehicleinfo.clearSelection()// 清空
          this.vehicleData = []
        } else {
          for (let b = 0; b < this.vehicleData.length; b++) {
            if (row.chassisNo === this.vehicleData[b].chassisNo) {
              this.vehicleData.splice(b, 1)
              break
            }
          }
        }
      }
    },
    gotoView (type, id) {
      let query = {}
      let name = 'rm-coursevehiclerela-add-or-update'
      query.courseVehicleRelaId = id
      if (type === 'view') {
        name = 'rm-coursevehiclerela-view'
        this.$router.push({
          name: name,
          query: query
        })
      } else if (type === 'update') {
        this.$router.push({
          name: name,
          query: query
        })
      } else if (type === 'delete') {
        this.deleteHandle(id)
      }
    },
    addUpdate (row) {
      let name = 'rm-coursevehiclerela-add-or-update'
      let pkName = (row != null) ? row.courseVehicleRelaId : undefined
      let query = {}
      query.courseVehicleRelaId = pkName
      this.$router.push({
        name: name,
        query: query
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    // 状态转换
    statusFormatter (row) {
      return Vue.filter('coverEnum')(row.status, 'status')
    },
    // 是否有车辆配置信息转换
    isUploadFormatter (row) {
      return Vue.filter('coverEnum')(row.isUpload, 'confirmState')
    },
    // 车辆分类转换
    vehicleClassFormatter (row) {
      return Vue.filter('coverEnum')(row.vehicleClassification, 'vehicleClass')
    },
    // 全选
    selectAllRedio (selection) {
      let _this = this
      if (selection) {
        let vehicleDataB = []
        if (_this.vehicleData && _this.vehicleData.length > 0) {
          _this.vehicleData.forEach(function (item) {
            vehicleDataB.push(item)
          })
        }
        if (selection.length > 0) {
          for (var i = 0; i < selection.length; i++) {
            let hasFlg = false
            if (vehicleDataB && vehicleDataB.length > 0) {
              for (var l = 0; l < vehicleDataB.length; l++) {
                if (vehicleDataB[l].chassisNo === selection[i].chassisNo) {
                  hasFlg = true
                }
              }
            }
            if (!hasFlg) {
              _this.vehicleData.push(selection[i])
            }
          }
        } else {
          _this.vehicleData = []
          if (vehicleDataB && vehicleDataB.length > 0) {
            for (var j = 0; j < vehicleDataB.length; j++) {
              let hasFlg = false
              for (var k = 0; k < _this.dataList.length; k++) {
                if (vehicleDataB[j].chassisNo === _this.dataList[k].chassisNo) {
                  hasFlg = true
                }
              }
              if (!hasFlg) {
                _this.vehicleData.push(vehicleDataB[j])
              }
            }
          }
        }
      }
    },
    // 确认
    onOk: function () {
      let _this = this
      _this.$emit('onOk', _this.vehicleData)
      _this.$refs.selectVehicleinfo.clearSelection()
      this.$refs.classRef.resetChecked()
    },
    // 关闭dialog
    closeSuboVehicleDlg () {
      this.vehicleData = []
      this.$emit('closeSuboVehicleDlg')
    },
    getVehicleList (args) {
      // 判断返回数组是否大于0，否则前台会报错
      if (args && args !== '' && args.length > 0) {
        let vehicleArr = []
        args.forEach(function (item) {
          vehicleArr.push(item.id)
        })
        this.dataForm.vehicleClassList = vehicleArr
      } else {
        this.dataForm.vehicleClassList = ''
      }
    },
    // 重置查询条件
    resetQueryData () {
      this.page = 1
      this.dataForm = {
        courseNo: '',
        chassisNo: '',
        label: [],
        labelTypeName: '',
        coursecName: '',
        classCnNames: '',
        teamcName: '',
        vehicleClassification: '',
        priority: '',
        stationName: '',
        subordinateSiteName: '',
        subordinateSiteIdList: [],
        statusList: ['10']
      }
      // this.selectTable = []
      this.siteSelectTable = []
      this.$refs.classRef.resetChecked()
      this.checkList = []
      this.$refs.tagTree && this.$refs.tagTree.isReset()
      this.vehicleData = []
      this.vehicleList = []
      this.$refs.selectVehicleinfo.clearSelection()
      this.getDataList()
    },
    // 关闭所属场地
    closeSuboSiteDlg () {
      this.isShowSuboSite = false
    },
    // 点击所属场地确定带回
    bringBack (selection) {
      let rowData = selection
      let siteCnName = ''
      let siteId = []
      for (var i = 0; i < rowData.length; i++) {
        siteCnName = siteCnName + rowData[i].siteCnName + ','
        siteId.push(rowData[i].id)
      }
      siteCnName = siteCnName.substr(0, siteCnName.length - 1)
      this.dataForm.subordinateSiteIdList = siteId
      this.dataForm.subordinateSiteName = siteCnName
      this.isShowSuboSite = false
      this.siteSelectTable = selection
    },
    // 点击所属场地打开弹窗
    showSuboSiteDlg () {
      this.isShowSuboSite = true
      this.$refs.suborSiteRef.initSuborSite()
    },
    // 双击选择车辆数据
    // onDbVehicle (val) {
    //   if (val) {
    //     if (this.vehicleData) {
    //       for (var i = 0; i < this.vehicleData.length; i++) {
    //         if (String(this.vehicleData[i].id) === String(val.id)) {
    //           this.$message.warning(this.$t('res.vehinfo.ondb'))
    //           return false
    //         }
    //       }
    //     }
    //     this.vehicleData.push(val)
    //     val.chassisNo = val.chassisNo
    //   }
    // },
    // 打开页面时，回填勾选
    querSelect () {
      // this.$refs.selectVehicleinfo.clearSelection()
      if (this.vehicleData && this.vehicleData.length > 0) {
        var map = new Map()
        this.vehicleData.forEach(function (item, index) {
          map.set(String(item.id), item)
        })
        let _this = this
        _this.dataList.forEach(function (dataitem, dataindex) {
          if (map.has(String(dataitem.id))) {
            _this.$refs.selectVehicleinfo.toggleRowSelection(dataitem)
          }
        })
      }
    },
    // 删除已选备件
    handleClose (data) {
      for (let a = 0; a < this.dataList.length; a++) {
        if (data.chassisNo === this.dataList[a].chassisNo) {
          this.$refs.selectVehicleinfo.toggleRowSelection(this.dataList[a], false)// 选择当前行
          break
        }
      }
      this.vehicleData.splice(this.vehicleData.indexOf(data), 1)
    },
    queryVehiclerela () {
      this.page = 1
      this.getDataList()
    },
    // 控制可选项
    checkboxT (row, index) {
      let _this = this
      let checkFlg = 1
      if (_this.vehicleInfoList && _this.vehicleInfoList.length > 0) {
        _this.vehicleInfoList.forEach(function (item) {
          if (row.chassisNo === item.chassisNo) {
            checkFlg = 0
          }
        })
      }
      return checkFlg
    },
    vehicleLabelShow () {
      this.vehicleLabelShowFlg = true
    },
    vehicleLabelLeave () {
      this.vehicleLabelShowFlg = false
    },
    vehicleLabelName () {
      this.dataForm.label = []
      this.dataForm.labelTypeName = ''
      this.checkList = []
      this.vehicleLabelShowFlg = false
      this.$refs.tagTree.isReset()
    },
    siteSeleteShow () {
      this.siteSeleteShowFlg = true
    },
    siteSeleteLeave () {
      this.siteSeleteShowFlg = false
    },
    siteSeleteName () {
      // this.selectTable = []
      this.dataForm.subordinateSiteIdList = []
      this.dataForm.subordinateSiteName = ''
      this.siteSeleteShowFlg = false
    }
  }
}
</script>
<!--<style>-->
  <!--.selectRadioClass thead .el-table-column&#45;&#45;selection .cell {-->
    <!--display: none !important;-->
  <!--}-->
<!--</style>-->
<style>
.location-layout22 .el-input {
  width: 80px !important;
}
.location-layout22 .el-input__inner {
  width: 80px !important;
}
.link-delete-temp:hover {
  cursor: pointer;
  text-decoration: none !important;
}
.holder:empty::before {
  color: #bbb;
  content: attr(placeholder);
}
</style>
